export default __webpack_public_path__ + "static/media/freebee3.7eff7d6a.png";